export const SUBPROCESS_PUBLISH = 'SUBPROCESS_PUBLISH'
export const SUBPROCESS_SELECT = 'SUBPROCESS_SELECT'
